import { useRef } from "react";
import { v4 as uuidv4 } from "uuid";

export function generateComponentId(prefix = "chart") {
  return `${prefix}-${uuidv4()}`;
}

export function useUniqueComponentId(prefix = "chart") {
  const idRef = useRef(null);
  if (idRef.current == null) {
    idRef.current = generateComponentId(prefix);
  }
  return idRef.current;
}

